





















import { Component, Vue } from "vue-property-decorator";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { ITemplate } from "@/models/templates";
import TemplateProvider from "@/components/app/global/templates/templateProvider.vue";
import NotificationTemplateAddEditForm from "@/components/app/global/templates/notifications/templateAddEditForm.vue";
import { TemplateTypes } from "@/data/enums/templates";

@Component({
  components: {
    TemplateProvider,
    NotificationTemplateAddEditForm
  }
})
export default class AdminEmailTemplatesForm extends Vue {
  public templateId!: ITemplate["id"];

  public emailNotificationChannel = NotificationChannelCodes.EMAIL;
  public templateType = TemplateTypes.NOTIFICATION;

  public created() {
    this.templateId = this.$_.get(this.$route.params, "templateId");
  }

  public get title() {
    if (this.$route.name === "adminAddEmailTemplate") {
      return this.$i18n.t("_action.create_object", {
        object: (this.$i18n.t("_.template") as string).toLowerCase()
      });
    } else {
      return this.$i18n.t("_action.edit_object", {
        object: (this.$i18n.t("_.template") as string).toLowerCase()
      });
    }
  }

  // Methods

  public onDuplicate({ newTemplate }) {
    this.$router.replace({
      name: "adminEditEmailTemplate",
      params: { templateId: newTemplate.id }
    });
  }

  public onChange({ templateId }) {
    this.$router.replace({
      name: this.$route.name as string,
      params: { templateId }
    });
  }

  public onRestored({ templateId }: { templateId: ITemplate["id"] }) {
    this.$router.replace({
      name: "adminEditEmailTemplate",
      params: { templateId }
    });
  }
}
